import styled from "styled-components";
import { Title } from "../../../Step2LegacyOptions/Components/LegacyAccordions/styles";
import { PillButtonSelect } from "../../../Step2LegacyOptions/Components/LegacyAccordions/styles";

export const MainWrapper = styled.div`
  border: 1px solid #d4d4d4;
  margin-bottom: 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const TitleWrap = styled(Title)`
  padding: 20px 0 7px 30px;
`;

export const ContentWrap = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #505050;
  padding-left: 30px;
  margin-bottom: ${props => props.marginBottom};
  width: 700px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 273px;
    padding-left: 20px;
    font-size: 14px;
  }
`;

export const PillButtonSelectSpace = styled(PillButtonSelect)`
  margin: 0 0 21px 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 20px 30px;
  }
`;

export const ShowMoreButton = styled(PillButtonSelectSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 20px 20px;
  }
`;
